"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFormHelperTextStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeFormHelperTextStyles = function makeFormHelperTextStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          marginTop: primitives.spacings["1"],
          color: tokens.colors["ink-on-background-60"].rgb
        }, tokens.typography["short-copy-small"]), {}, {
          "& > svg": {
            paddingRight: primitives.spacings["1"]
          },
          '&[class*="MuiFormHelperText--success"]': {
            color: tokens.colors["ink-on-background"].rgb
          },
          "&.Mui-error": {
            fontWeight: primitives.fontWeights.stout,
            opacity: 1
          }
        }),
        contained: {
          marginLeft: 0,
          marginRight: 0
        }
      }
    }
  };
};

exports.makeFormHelperTextStyles = makeFormHelperTextStyles;